// import React, {useEffect, useState} from "react";
// import {isMobile} from "../../../../utils";
// import {useDispatch} from "react-redux";
// import ApiAuth from "../../../../API/ApiAuth";
// import {toast} from "react-toastify";
// import GetFeatureInfo from "../GetFeatureInfo";
// import CustomAutocomplete from "../../../../Helper/CustomAutocomplete";
// import Auth from "../../../../Redux/Actions/Auth";

// /* ──────────────────────────────────────────────────────────
//    🔸 Helper to keep “starts‑with” matches on top, rest below
//    ──────────────────────────────────────────────────────────*/
// const rankAndSort = (list, query) => {
//     const q = query.toLowerCase();

//     return list
//         .filter((item) => item.name?.toLowerCase().includes(q)) // keep only matches
//         .sort((a, b) => {
//             const aStarts = a.name.toLowerCase().startsWith(q);
//             const bStarts = b.name.toLowerCase().startsWith(q);

//             // same bucket ⇒ alphabetical
//             if (aStarts === bStarts) return a.name.localeCompare(b.name);

//             // starts‑with bucket first
//             return aStarts ? -1 : 1;
//         });
// };

// function ElasticSearch(props) {
//     const dispatch = useDispatch();

//     const [housingSchemes, setHousingSchemes] = useState([]);
//     const [plots, setPlots] = useState([]);
//     const [selectedScheme, setSelectedScheme] = useState({});

//     /* ───────────── Housing‑scheme search ───────────── */
//     const handleOnSearch = async (query) => {
//         if (!query || query.length < 1) {
//             setHousingSchemes([]);
//             return;
//         }

//         try {
//             const {success, data} = await ApiAuth.plotHousingSearch(query);
//             if (success) {
//                 setHousingSchemes(rankAndSort(data, query)); // ✨ new logic
//             } else {
//                 setHousingSchemes([]);
//             }
//         } catch (err) {
//             setHousingSchemes([]);
//             toast.error(err.message || "Search error");
//         }
//     };

//     /* ───────────── Plot search inside selected scheme ───────────── */
//     const handleFormPlotSearch = async (search) => {
//         const res = await ApiAuth.plotSearchByHousingScheme(
//             selectedScheme.id,
//             search
//         ); // your API
//         return res;
//     };

//     /* ───────────── When user chooses a scheme ───────────── */
//     const handleOnSelect = (item) => {
//         const {id, name} = item;
//         setSelectedScheme({id, name});
//         setPlots([]); // clear previous plots
//     };

//     /* ───────────── When user chooses a plot ───────────── */
//     const handleOnSelectPlotSearch = (item) => {
//         const {id, centeriod} = item;
//         if (!id || !centeriod) return;

//         try {
//             const LatLng = {
//                 lng: parseFloat(centeriod.split(",")[1]),
//                 lat: parseFloat(centeriod.split(",")[0]),
//             };

//             props.setcentroid(LatLng);
//             props.map.setView(LatLng, 19);

//             GetFeatureInfo(LatLng, props.map, props.setplotData, dispatch);
//             setSelectedScheme(() => ({
//                 id: '',
//                 name: ''
//             }));
//             setPlots([]);
//             dispatch(Auth.hs_draw(''))
//         } catch (e) {
//             toast.error(e.message);
//         }
//     };

//     /* ───────────── Initial list of schemes (for client‑side mode) ───────────── */
//     const getHousingSchemeData = async () => {
//         const response = await ApiAuth.getAllHousingSchemeList();
//         setHousingSchemes(response.data || []);
//     };

//     useEffect(() => {
//         getHousingSchemeData();
//     }, []);

//     /* ───────────── UI helpers ───────────── */
//     const formatResult = (item) => (
//         <div className="search-result-item">
//             <span>{item.name}</span>
//         </div>
//     );

//     const handleSearchHs = async (query) => {
//         const res = await ApiAuth.plotHousingSearch(query); // your API
//         return res;
//     };

//     const handleSelectHs = (item) => {
//         dispatch(Auth.hs_draw(item.geom))
//         setSelectedScheme(() => ({id: item.id, name: item.name}));
//         setPlots([]);
//     };

//     /* ───────────── Render ───────────── */
//     return (
//         <>
//             <div style={styles.panelStyle} className="drop-shadow">
//                 {/* Logo */}
//                 <div>
//                     <img
//                         style={{width: "115px", height: "91px"}}
//                         onClick={() => (window.location.href = "/")}
//                         src={require("../../../../assets/nab-logo.png").default}
//                         alt="Property with surety"
//                     />
//                 </div>

//                 {/* Housing scheme search */}
//                 <div className="mt-2">

//                     <CustomAutocomplete
//                         onSearch={handleSearchHs}
//                         onSelect={handleSelectHs}
//                         value={selectedScheme.name}
//                         placeholder="Search Housing scheme"
//                     />
//                 </div>

//                 {/* Plot search (only after scheme selected) */}
//                 {selectedScheme.id && (
//                     <div className="mt-2">

//                         <CustomAutocomplete
//                             value={''}
//                             onSearch={handleFormPlotSearch}
//                             onSelect={handleOnSelectPlotSearch}
//                             placeholder="Search Plot"
//                         />
//                     </div>
//                 )}
//             </div>
//         </>
//     );
// }

// /* ───────────── Styles ───────────── */
// const styles = {
//     hsPanelStyle: {
//         width: isMobile() ? 240 : 270,
//         alignItems: "center",
//         padding: 10,
//         borderRadius: 10,
//         paddingTop: 15,
//         marginLeft: 7,
//         position: "absolute",
//         zIndex: 2000,
//         cursor: "pointer",
//     },
//     panelStyle: {
//         width: isMobile() ? 240 : 270,
//         alignItems: "center",
//         padding: 10,
//         borderRadius: 10,
//         paddingTop: 15,
//         marginLeft: 7,
//         position: "absolute",
//         zIndex: 1500,
//         cursor: "pointer",
//         textAlign: "center",
//     },
// };

// export default ElasticSearch;

import React, { useEffect, useState } from "react";
import { isMobile } from "../../../../utils";
import { useDispatch } from "react-redux";
import ApiAuth from "../../../../API/ApiAuth";
import { toast } from "react-toastify";
import GetFeatureInfo from "../GetFeatureInfo";
import CustomAutocomplete from "../../../../Helper/CustomAutocomplete";
import Auth from "../../../../Redux/Actions/Auth";

const ElasticSearch = (props) => {
  const dispatch = useDispatch();

  const [selectedScheme, setSelectedScheme] = useState({});
  const [subSectors, setSubSectors] = useState([]);
  const [selectedSubSector, setSelectedSubSector] = useState({});
  const [plots, setPlots] = useState([]);

  const handleSearchHs = async (query) => {
    const res = await ApiAuth.plotHousingSearch(query);
    return res;
  };

  const handleSelectHs = async (item) => {
    dispatch(Auth.hs_draw(item.geom));
    setSelectedScheme({ id: item.id, name: item.name });
    setSelectedSubSector(()=>({}));
    setPlots([]);

    try {
      const res = await ApiAuth.getSubSectorsByScheme(item.name); // 🔄 Use housing_scheme_name
      if (res.success && Array.isArray(res.data)) {
        setSubSectors(res.data);
      } else {
        setSubSectors([]);
        toast.warning("No sub-sectors found.");
      }
    } catch (error) {
      toast.error("Failed to fetch sub-sectors.");
    }
  };

  const handleSubSectorChange = (e) => {
    const id = e.target.value;
    const selected = subSectors.find((s) => s.id === parseInt(id));
    console.log(selected);

    if (selected) {
      setSelectedSubSector(()=>({ id: selected.id, name: selected.phase_sector_name }));
      localStorage.setItem('mws_phase_sector',JSON.stringify({ id: selected.id, name: selected.phase_sector_name }))
      setPlots([]);
      console.log(selectedSubSector,'selected sub')
    }
  };

  /*// const handleFormPlotSearch = async (query) => {
  //   const res = await ApiAuth.plotSearchByHousingScheme(selectedScheme.id, query);
  //   return res;
  // };*/

  const handleFormPlotSearch = async (query) => {
    let mws_phase_sector = localStorage.getItem('mws_phase_sector');
    if (mws_phase_sector !==undefined){
      mws_phase_sector = JSON.parse(mws_phase_sector)
    }

    const payload = {
      housing_scheme_id: selectedScheme.id,
      address_search: query,
      phase_id: mws_phase_sector.id??subSectors.id,
    };
  
    try {
      const response = await ApiAuth.plotSearch(payload);
      return response;
    } catch (err) {
      toast.error(err.message);
      return { success: false, data: [] };
    }
  };
  

  const handleOnSelectPlotSearch = (item) => {
    const { centeriod } = item;
    if (!centeriod) return;

    try {
      const LatLng = {
        lng: parseFloat(centeriod.split(",")[1]),
        lat: parseFloat(centeriod.split(",")[0]),
      };

      props.setcentroid(LatLng);
      props.map.setView(LatLng, 19);
      GetFeatureInfo(LatLng, props.map, props.setplotData, dispatch);
      dispatch(Auth.hs_draw(""));

     /* setSelectedScheme({});
      setSelectedSubSector({});
      setPlots([]);*/
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <div style={styles.panelStyle} className="drop-shadow">
      {/* Logo */}
      <div>
        <img
          style={{ width: "115px", height: "91px" }}
          onClick={() => (window.location.href = "/")}
          src={require("../../../../assets/nab-logo.png").default}
          alt="Property with surety"
        />
      </div>

      {/* Housing Scheme Autocomplete */}
      <div className="mt-2">
        <CustomAutocomplete
          onSearch={handleSearchHs}
          onSelect={handleSelectHs}
          value={selectedScheme.name}
          placeholder="Search Housing Scheme"
        />
      </div>

      {/* Sub Sector Dropdown */}
      {selectedScheme.id && (
       <div className="mt-2">
       <select
         className="form-select"
         value={selectedSubSector.id || ""}
         onInput={handleSubSectorChange}
       >
         <option value="">Select Sub Sector</option>
         {subSectors.map((s) => (
           <option key={s.id} value={s.id}>
             {s.phase_sector_name}
           </option>
         ))}
       </select>
     </div>
      )}

      {/* Plot Search Autocomplete */}
      {selectedSubSector.id && (
        <div className="mt-2">
          <CustomAutocomplete
            value={""}
            onSearch={handleFormPlotSearch}
            onSelect={handleOnSelectPlotSearch}
            placeholder="Search Plot"
          />
        </div>
      )}
    </div>
  );
};

const styles = {
  panelStyle: {
    width: isMobile() ? 240 : 270,
    alignItems: "center",
    padding: 10,
    borderRadius: 10,
    paddingTop: 15,
    marginLeft: 7,
    position: "absolute",
    zIndex: 1500,
    cursor: "pointer",
    textAlign: "center",
  },
};

export default ElasticSearch;




